import * as React from 'react';
import { formatDate, getEmployeeName, getSchema } from '../../../../utils';
import { ItemField } from './itemField';
import { ItemFieldProps } from './types';
import {
  ArchiveSymbol,
  KeepActiveSymbol,
  Maintenance
} from '../../../Icon/icon';
import TooltipPopover from '../../../Popover/popover';
import { useSelector } from '../../../../utils/useSelector';
import { NodeType } from '../../../../enums/NodeType';
import { Metadata } from '../../../../types';

export const ItemExpiryField = (f: ItemFieldProps) => {
  if (!f.view?.props?.isMyExpiryDashboard) {
    return <ItemField {...f} />;
  }
  const { item } = f;
  return (
    <div className="item-card-field-container">
      <ItemField {...f} />
      {!!item &&
        !!item?.props?.expiryRequestType &&
        item?.props?.expiryRequestType?.toUpperCase()?.indexOf('ARCHIVE') <
          0 && (
          <div className="expiry-info-container">
            <TooltipPopover
              packed={true}
              type="info"
              pointerPosition="top"
              content={
                <div className="popover-description-container">
                  <div>{item?.props?.expiryRequestType} by</div>
                  <div>{getExpiryByEmployeeName(item)}</div>
                  <div>{formatDate(item?.props?.expiryRequestDate)}</div>
                </div>
              }
            >
              <div>
                <KeepActiveSymbol />
              </div>
            </TooltipPopover>
          </div>
        )}
      {!!item &&
        !!item?.props?.expiryRequestType &&
        item?.props?.expiryRequestType?.toUpperCase()?.indexOf('ARCHIVE') >=
          0 && (
          <div className="expiry-info-container">
            <TooltipPopover
              packed={true}
              type="info"
              pointerPosition="top"
              content={
                <div className="popover-description-container">
                  {item?.props?.expiryRequestType == 'Pending Archive' && (
                    <div>Pending Archive</div>
                  )}
                  {item?.props?.expiryRequestType != 'Pending Archive' && (
                    <>
                      <div>{item?.props?.expiryRequestType} by</div>
                      <div>{getExpiryByEmployeeName(item)}</div>
                      <div>{formatDate(item?.props?.expiryRequestDate)}</div>
                    </>
                  )}
                </div>
              }
            >
              <div>
                <ArchiveSymbol />
              </div>
            </TooltipPopover>
          </div>
        )}
      <MaintenanceCOERecommendation item={item} />
    </div>
  );
};

const getExpiryByEmployeeName = item => {
  return !!item?.props?.expiryRequestByName
    ? item?.props?.expiryRequestByName
    : !!item?.props?.expiryRequestBy?.length
    ? item?.props?.expiryRequestBy[0]?.props?.name
    : 'Unknown';
};

const MaintenanceCOERecommendation = ({
  item
}: Pick<ItemFieldProps, 'item'>) => {
  const displayField = useSelector(
    s =>
      getSchema(
        s.planning.selectedWorkspace?.schemas,
        NodeType.MaintenanceCOEProposal
      )?.props?.displayField
  );
  if (!displayField) return null;
  if (!item?.props?.maintenanceCOERecommendation?.length) return null;
  const expiryAction = item.props.maintenanceCOERecommendation[0];
  if (!expiryAction?.props) return null;
  const actionType = expiryAction.props[displayField];
  if (!actionType) return null;
  const requestedBy = getEmployeeName(item.props.maintenanceCOEModifiedBy);
  const requestedDate = getEmployeeName(item.props.maintenanceCOEModifiedBy, {
    auditDateOnly: true
  });
  return (
    <div className="expiry-info-container">
      <TooltipPopover
        packed={true}
        type="info"
        pointerPosition="top"
        content={
          <div className="popover-description-container">
            <div>{actionType} requested by Maintenance COE:</div>
            <div>{requestedBy || 'Unknown'}</div>
            {!!requestedDate && <div>{requestedDate}</div>}
          </div>
        }
      >
        <div>
          <Maintenance />
        </div>
      </TooltipPopover>
    </div>
  );
};
